import { useState, useEffect, useCallback } from 'react';
import { renewalsAPI } from '../services/api';

export function useRecommendations(policyId) {
  const [list, setList] = useState([]);
  const [best, setBest] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!policyId) return;
    setLoading(true);
    setError(null);
    try {
      const [recs, b] = await Promise.all([
        renewalsAPI.getRecommendations(policyId),
        renewalsAPI.getBestRecommendation(policyId),
      ]);
      setList(Array.isArray(recs) ? recs : []);
      setBest(b || null);
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Failed to load recommendations');
      setList([]);
      setBest(null);
    } finally {
      setLoading(false);
    }
  }, [policyId]);

  useEffect(() => {
    load();
  }, [load]);

  const dismiss = useCallback(async (recId, reason) => {
    try {
      await renewalsAPI.dismissRecommendation(recId, reason);
      await load();
    } catch (e) {
      throw e;
    }
  }, [load]);

  return { list, best, loading, error, reload: load, dismiss };
}
